<template>
  <div>巡检页面</div>
</template>

<script>
export default {
  name: "Inspection",
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
div {
  color: black;
}
</style>